import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import advanced from "dayjs/plugin/advancedFormat";
import { google, outlook, yahoo, ics, CalendarEvent } from "calendar-link";
import {
  DrillModal,
  TabClassHomeWork,
} from "components/organisms/TabClassHomeWork";
import { ImageIcon } from "components/molecules/ImageIcon";
import { Tab } from "components/molecules/Tab";
import { TextOptionBtn } from "components/molecules/TextOptionBtn";
import { DropDown, Button, Typography } from "components/atoms";
import { useAppDispatch, useAppSelector, useScreenSize } from "hooks";
import { 
  DASHBOARD_PROGRAME, 
  DESKTOP_WIDTH, 
  MCAT_TEST_TYPE, 
  MOBILE_WIDTH, 
  SELF_PACED_PROGRAME, 
  TAB_WIDTH 
} from "utils/constants";
import { CalenderIcon, CloseIcon } from "components/atoms/Icon";
import { TabFeedback } from "components/organisms/TabFeedback";
import { OnboardMessageBody } from "../OnboardMessageBody";
import { TextEditor } from "../TextEditor";
import { Modal } from "../Modal";
import { ConditionalBtns } from "./ConditionalBtns";
import { AddToExternalCalenderList } from "./AddToExternalCalenderList";
import { AlternateSessionsList } from "./AlternateSessionsList";
import { formatToLocalDate } from "utils/functions/formatToLocalDate";
import { getTimeZone } from "utils/functions/getTimeZone";
import { useSegmentReFetch } from "context";
import {
  homeApi,
  useGetCourseworkQuery,
  useGetOverallProgressQuery,
  useGetTestScoresAndPerformanceQuery,
} from "services/homeApi";
import { useGetPracticeTestsQuery, useGetTestResultsQuery } from "services/practice";
import { getObjectKeysByValue } from "services/helpers";
import {
  reStructureSegment,
  replaceArrayOfObjects,
} from "utils/functions/courseWorkReStructure";
import { RefreshModal } from "../RefreshModal";
import { getTimeFilterInput } from "utils/functions/getTimeFilterInput";
import { decodeToken } from "utils/functions/decodeToken";
import "./index.scss";
import { useLazyGetStudyPlannerEventsQuery } from "services/studyPlanner";
import { useLazyGetAiRecommendationsQuery } from "services/aiRecommendations";
import { ai_mcat_chat_status } from "state/reducers/layoutSlice";
import { openExternalUrl } from "utils/functions/openExternalUrl";

interface IProps {
  borderColor: string;
  isTabShow: boolean;
  groups?: any;
  styles?: string;
  title: string;
  startTime?: string;
  endTime?: string;
  timeSpan?: string;
  profileImage?: string;
  messageIcon?: boolean;
  name?: string;
  btnLabel?: string;
  userGuid?: string;
  contentObjectGuid?: string;
  contentObjectType?: string;
  segmentObj?: any;
  theme: "light" | "dark";
  index?: number;
  itemPageNo?: number;
  email?: string;
}

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advanced);
const guessedTimezone = dayjs.tz.guess();

export const DetailCard = ({
  borderColor = "black",
  isTabShow,
  groups,
  styles,
  title = "Test 4",
  startTime = "Saturday. August 12",
  endTime = "10:00 AM - 5:00 PM EDT",
  timeSpan = "",
  profileImage,
  messageIcon,
  btnLabel,
  name,
  userGuid,
  contentObjectGuid,
  contentObjectType,
  segmentObj,
  theme,
  index,
  itemPageNo,
  email,
}: IProps) => {
  const [dropDownSelection, setDropDownSelection] = useState<
    null | string | { [key: number]: string }
  >(null);
  const [isMessageOnBoarOpen, setIsMessageOnBoardOpen] = useState(false);
  const [isExternalCalenderListShow, setIsExternalCalenderListShow] =
    useState(false);
  const [googleLink, setGoogleLink] = useState("");
  const [yahooLink, setYahooLink] = useState("");
  const [outLookLink, setOutLookLink] = useState("");
  const [icsLink, setIcsLink] = useState("");
  const { data, setData, selectedBtn, selectedSession, subject } = useSegmentReFetch();
  const screen = useScreenSize();

  const { aiMCATChatDrawerStatus } = useAppSelector(
    (state: { layout: { aiMCATChatDrawerStatus: ai_mcat_chat_status } }) =>
      state.layout
  );
  const [openUpdateModalState, setOpenUpdateModalState] = useState<any>({
    isOpen: false,
    data: null,
  });

  const [isRefreshModalOpen, setIsRefreshModalOpen] = useState({
    isOpen: false,
    data: "",
  });

  const [hasPerformedRefresh, setHasPerformedRefresh] = useState(false);
  const [isAlternateSessionsExpanded, setIsAlternateSessionsExpanded] = useState(false);

  const calendarRef = useRef<HTMLDivElement>(null);

  const payload = decodeToken();

  const dispatch = useAppDispatch();

  const userId = payload ? payload.userid : null;
  const productCode = payload ? payload.productcode : null;
  const offeringCode = payload ? payload.offeringcode : null;
//  const alternateScheduleOfferingCodesA = ["170205", "558301", "562544", "566088", "558860", "557306", "557307"];
//  const alternateScheduleOfferingCodesB = ["558403"];
//  const isAlternateScheduleEnabledA = 0 <= alternateScheduleOfferingCodesA.indexOf(offeringCode);
//  const isAlternateScheduleEnabledB = 0 <= alternateScheduleOfferingCodesB.indexOf(offeringCode);
  const isAlternateScheduleEnabled = payload.hasOwnProperty("isalternatescheduleenabled") && payload.isalternatescheduleenabled.toLowerCase() === "true";

  const isDashboard =
    payload &&
    payload.hasOwnProperty("programtype") &&
    payload.programtype === DASHBOARD_PROGRAME;

  const isSelfPaced =
    payload &&
    payload.hasOwnProperty("programtype") &&
    payload.programtype === SELF_PACED_PROGRAME;

  const testtype =
    payload && payload.hasOwnProperty("testtype") && payload.testtype;

  const handleStyleWithDrower = () => {
    return (
      screen.width > DESKTOP_WIDTH &&
      screen.width < 1600 &&
      aiMCATChatDrawerStatus === "open"
    );
  };

  const handleRefreshModalClose = () => {
    setIsRefreshModalOpen((prev) => ({
      ...prev,
      isOpen: false,
      data: "",
    }));
  };

  const handleUpdateModalClose = () => {
    setOpenUpdateModalState((prev: any) => ({
      ...prev,
      isOpen: false,
      data: null,
    }));
  };

  const handleScoreReportModalOpen = (url: string) => {
    openExternalUrl({
      url,
      title: "Score Report",
      testType: testtype,
      dispatch,
    });
  };

  const { refetch, isFetching } = useGetCourseworkQuery({
    page: itemPageNo ? itemPageNo : 1,
    ...(isDashboard ? {
    selectedOption: parseInt(getObjectKeysByValue(selectedBtn, true)[0], 10),
    } : {}),
    ...(isDashboard ? {
    timeFilter:
      selectedSession === null
        ? 1
        : getTimeFilterInput(Object.values(selectedSession)[0]),
    } : {}),
    ...(isSelfPaced && testtype === MCAT_TEST_TYPE ? {
      subject: subject
    } : {})
  });

  const { refetch: refetchTestScores, isFetching: isFetchingTestScores } =
    useGetTestScoresAndPerformanceQuery();

  // Practice page queries: refresh practice tests list and test results graph
  const { refetch: refetchPracticeTests, isFetching: isFetchingPracticeTests } =
    useGetPracticeTestsQuery();
  const { refetch: refetchPracticeResults, isFetching: isFetchingPracticeResults } =
    useGetTestResultsQuery();

  const [triggerRefetchAiRecommendation, aiRecommendationRefetchResult] =
    useLazyGetAiRecommendationsQuery();

  const {
    refetch: refetchOverAllProgress,
    isFetching: isFetchingOverallProgress,
  } = useGetOverallProgressQuery({
    Userid: userId,
    Productcode: productCode,
    Offeringcode: offeringCode,
  });

  const [triggerRefetchStudyPlaner, StudyPlannerRefetchResult] =
    useLazyGetStudyPlannerEventsQuery();

  const handleRefreshCourseWork = async () => {
    const promises = [
      refetch(),
      refetchTestScores(),
      refetchOverAllProgress(),
      refetchPracticeTests(),
      refetchPracticeResults(),
      triggerRefetchStudyPlaner(),
      triggerRefetchAiRecommendation(),
    ];

    Promise.allSettled(promises).then((responses: any) => {
      if (responses[0].status === "fulfilled") {
        const deStructuredArray = reStructureSegment(responses[0].value.data);
        const updatedArray = replaceArrayOfObjects(deStructuredArray, data);
        setData([...updatedArray]);
      }
      handleRefreshModalClose();
    });
    dispatch(homeApi.util.invalidateTags(["Coursework"]));
  };

  const handleRefreshModalOpen = () => {
    setIsRefreshModalOpen((prev) => ({
      ...prev,
    }));
  };

  const formatDate = (dateInput: string): string => {
    let date = dayjs.utc(dateInput).local().format("dddd, MMMM DD");
    return `${date}`;
  };

  const formatTimeRange = (dateTime: string): string => {
    let localTime = dayjs(dateTime).isValid()
      ? dayjs.utc(dateTime).local().format("hh:mm A")
      : dateTime;
    return localTime;
  };

  const handleMessageOnboardClose = () => {
    setIsMessageOnBoardOpen(false);
  };

  const handleAddToExternalCalender = (
    title: string,
    startTime: string,
    endTime: string
  ) => {
    let startTimeString = `${formatToLocalDate(startTime, "YYYY-MM-DD HH:mm:ss")} ${getTimeZone(startTime)}`;
    let endTimeString = `${formatToLocalDate(endTime, "YYYY-MM-DD HH:mm:ss")} ${getTimeZone(endTime)}`;

    const event: CalendarEvent = {
      title: title,
      start: startTimeString,
      end: endTimeString,
      description: "Online Classroom",
    };

    setGoogleLink(google(event));
    setOutLookLink(outlook(event));
    setYahooLink(yahoo(event));
    setIcsLink(ics(event));
    setIsExternalCalenderListShow((prev) => !prev);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      calendarRef.current &&
      !calendarRef.current.contains(event.target as Node)
    ) {
      setIsExternalCalenderListShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!groups) {
      setDropDownSelection(null);
      return;
    }
    const keys = Object.keys(groups);
    const firstKey = keys[0];

    setDropDownSelection((prev) => {
      if (prev == null) {
        return firstKey != null ? { 0: firstKey } : null;
      }
      const currentKey = Object.values(prev)[0];
      const stillValid = keys.includes(currentKey);
      return stillValid ? prev : (firstKey != null ? { 0: firstKey } : null);
    });
  }, [groups]);

  return (
    <>
      <div className="tile-container">
        <div
          className={classNames(
            "tile-wrapper",
            `default-border-${borderColor}`,
            handleStyleWithDrower() ? "tile-wrapper-with-drawer" : ""
          )}
        >
          <div
            className={classNames(
              "tile",
              { [`${styles}`]: styles },
              handleStyleWithDrower() ? "tile-with-drawer" : ""
            )}
          >
            {screen.width > MOBILE_WIDTH && screen.width <= TAB_WIDTH ? (
              <>
                <div className="tab-layout-detail-card">
                  <div
                    className={classNames("content-section", {
                      isTest: segmentObj && segmentObj.IsTestSegment,
                    })}
                  >
                    <div className="content-1">
                      <Typography label={title} variant="h5Bold" />
                    </div>

                    <div className="content-2">
                      <div>
                        <Typography
                          label={formatToLocalDate(startTime, "dddd, MMMM DD")}
                          variant="h7Med"
                        />
                      </div>

                      <div className="content-2-1">
                        <Typography
                          // label={`${formatTimeRange(startTime)} - ${formatTimeRange(endTime)} ${dayjs()
                          //   .tz(guessedTimezone)
                          //   .format("z")}`}
                          label={`${formatToLocalDate(
                            startTime,
                            "hh:mm A"
                          )} - ${formatToLocalDate(
                            endTime,
                            "hh:mm A"
                          )} ${dayjs().tz(guessedTimezone).format("z")}`}
                          variant="h8Book"
                        />
                        {segmentObj && segmentObj.IsTestSegment && (
                          <Typography
                            variant="h8Italic"
                            label="(Suggested Date & Time)"
                            styles="suggested-date-custom-style"
                          />
                        )}
                        {screen.width < MOBILE_WIDTH ? (
                          <CalenderIcon
                            color={theme === "light" ? "black" : "white"}
                          />
                        ) : null}
                      </div>
                    </div>
                    {screen.width > MOBILE_WIDTH ? (
                      <div
                        className="content-3"
                        id={`content-3-${index}`}
                        ref={calendarRef}
                      >
                        <Button
                          label="Add To External Calendar"
                          icon={true}
                          type="icon-text"
                          onClick={() =>
                            handleAddToExternalCalender(
                              title,
                              startTime,
                              endTime
                            )
                          }
                        />

                        {isExternalCalenderListShow ? (
                          <AddToExternalCalenderList
                            icsLink={icsLink}
                            googleLink={googleLink}
                            yahooLink={yahooLink}
                            outLookLink={outLookLink}
                            setIsExternalCalenderListShow={
                              setIsExternalCalenderListShow
                            }
                          />
                        ) : null}
                      </div>
                    ) : null}

                  </div>
                  <div
                    className={classNames(
                      "tab-layout-image-btn-section",
                      !profileImage && "non-image-btn"
                    )}
                  >
                    {profileImage ? (
                      <div className={classNames("image-section")}>
                        <ImageIcon
                          label={name ? name : "default name"}
                          icon={messageIcon}
                          email={email}
                          image={profileImage}
                          styles="img-text-icon-tile"
                          theme={theme}
                        />
                      </div>
                    ) : null}
                    <div
                      className={classNames("button-section", {
                        isTest: segmentObj && segmentObj.IsTestSegment,
                      })}
                    >
                      <ConditionalBtns
                        segment={segmentObj}
                        index={index}
                        refreshModalState={setIsRefreshModalOpen}
                        handleScoreReportModalOpen={handleScoreReportModalOpen}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div
                  className={classNames(
                    "content-section",
                    {
                      isTest: segmentObj && segmentObj.IsTestSegment,
                    },
                    handleStyleWithDrower() ? "content-section-with-drawer" : ""
                  )}
                >
                  <div className="content-1">
                    <Typography label={title} variant="h5Bold" />
                  </div>
                  <div
                    className={classNames(
                      "content-2",
                      handleStyleWithDrower() ? "content-2-with-drawer" : ""
                    )}
                  >
                    <div>
                      <Typography
                        label={formatToLocalDate(startTime, "dddd, MMMM DD")}
                        variant="h7Med"
                      />
                    </div>

                    <div
                      className={classNames(
                        "content-2-1",
                        handleStyleWithDrower() ? "content-2-1-with-drawer" : ""
                      )}
                    >
                      <Typography
                        label={`${formatToLocalDate(
                          startTime,
                          "hh:mm A"
                        )} - ${formatToLocalDate(endTime, "hh:mm A")} ${dayjs()
                          .tz(guessedTimezone)
                          .format("z")}`}
                        variant="h8Book"
                      />
                      {segmentObj && segmentObj.IsTestSegment && (
                        <Typography
                          variant="h8Italic"
                          label="(Suggested Date & Time)"
                          styles="suggested-date-custom-style"
                        />
                      )}
                      {screen.width < MOBILE_WIDTH ||
                      handleStyleWithDrower() ? (
                        <div
                          className="mobile-calendar-list-wrapper"
                          ref={calendarRef}
                        >
                          <CalenderIcon
                            color={theme === "light" ? "black" : "white"}
                            onClick={() =>
                              handleAddToExternalCalender(
                                title,
                                startTime,
                                endTime
                              )
                            }
                          />
                          {isExternalCalenderListShow ? (
                            <AddToExternalCalenderList
                              icsLink={icsLink}
                              googleLink={googleLink}
                              yahooLink={yahooLink}
                              outLookLink={outLookLink}
                              setIsExternalCalenderListShow={
                                setIsExternalCalenderListShow
                              }
                            />
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {screen.width > MOBILE_WIDTH && !handleStyleWithDrower() ? (
                    <div
                      className="content-3"
                      id={`content-3-${index}`}
                      ref={calendarRef}
                    >
                      <Button
                        label="Add To External Calendar"
                        icon={true}
                        type="icon-text"
                        onClick={() =>
                          handleAddToExternalCalender(title, startTime, endTime)
                        }
                      />
                      {isExternalCalenderListShow ? (
                        <AddToExternalCalenderList
                          icsLink={icsLink}
                          googleLink={googleLink}
                          yahooLink={yahooLink}
                          outLookLink={outLookLink}
                          setIsExternalCalenderListShow={
                            setIsExternalCalenderListShow
                          }
                        />
                      ) : null}
                    </div>
                  ) :
                  null}

                </div>
                {profileImage ? (
                  <div
                    className={classNames(
                      "image-section",
                      handleStyleWithDrower() ? "image-section-with-drawer" : ""
                    )}
                  >
                    <ImageIcon
                      label={name ? name : "default name"}
                      icon={messageIcon}
                      email={email}
                      image={profileImage}
                      styles="img-text-icon-tile"
                      theme={theme}
                    />
                  </div>
                ) : null}
                <div
                  className={classNames(
                    "button-section",
                    {
                      isTest: segmentObj && segmentObj.IsTestSegment,
                    },
                    handleStyleWithDrower() ? "button-section-with-drawer" : ""
                  )}
                >
                  <ConditionalBtns
                    segment={segmentObj}
                    index={index}
                    refreshModalState={setIsRefreshModalOpen}
                    handleScoreReportModalOpen={handleScoreReportModalOpen}
                  />
                </div>
              </>
            )}
          </div>

          {isAlternateScheduleEnabled && !segmentObj?.IsTestSegment && !segmentObj?.IsTopicFocusSegment && !segmentObj?.IsOfficeHoursSegment ? (
            <AlternateSessionsList
              segmentCode={segmentObj?.ProductOfferingSegmentCode}
              isExpanded={isAlternateSessionsExpanded}
              onToggle={() => setIsAlternateSessionsExpanded(prev => !prev)}
              theme={theme}
            />
          ) : null}

          {screen.width < MOBILE_WIDTH || handleStyleWithDrower() ? (
            <>
              {isTabShow && groups ? (
                <div className={classNames("drop-down-section")}>
                  <DropDown
                    data={[
                      ...Object.keys(groups).map((group: any) => group),
                      "Feedback",
                    ]}
                    setDropDownSelection={setDropDownSelection}
                    defaultSelected={dropDownSelection}
                  />

                  <div className="drop-down-content-section">
                    {dropDownSelection ?
                      Object.values(dropDownSelection)[0] === "Feedback" ? (
                      <TabFeedback
                        theme={theme}
                        data={segmentObj}
                        handleRefresh={handleRefreshCourseWork}
                      />
                    ) : (() => {
                        // Handle new ContentGroupingModel structure
                        const selectedGroup = groups[Object.values(dropDownSelection)[0]];
                        let contentToShow: any[] = [];
                        
                        if (selectedGroup) {
                          // If it's the new structure (ContentGroupingModel)
                          if (selectedGroup.NonDrillSmartContent || selectedGroup.DrillSmartContent) {
                            // Add NonDrillSmartContent items
                            if (selectedGroup.NonDrillSmartContent?.Content) {
                              contentToShow = [...selectedGroup.NonDrillSmartContent.Content];
                            }
                            // Add each DrillSmartGrouping as a single item (not the individual Content within it)
                            if (selectedGroup.DrillSmartContent && Array.isArray(selectedGroup.DrillSmartContent)) {
                              selectedGroup.DrillSmartContent.forEach((drillGroup: any) => {
                                // Add the entire DrillSmartGrouping object, marked so it can be identified
                                contentToShow.push({
                                  ...drillGroup,
                                  _isDrillSmartGrouping: true
                                });
                              });
                            }
                          } else if (Array.isArray(selectedGroup)) {
                            // Legacy structure: direct array of content objects
                            contentToShow = selectedGroup;
                          }
                        }
                        
                        return <TextOptionBtn
                          isMobile={
                            screen.width < MOBILE_WIDTH ||
                            handleStyleWithDrower()
                          }
                          isChatDrawerOpenOnSmallScreen={handleStyleWithDrower()}
                          updateModalState={setOpenUpdateModalState}
                          refreshModalState={setIsRefreshModalOpen}
                          exams={contentToShow}
                          textIconStyle="custom-home-mobile-text-icon-typography-style"
                          theme={theme}
                        />;
                      })()
                    : null}
                  </div>
                </div>
              ) : null}
            </>
          ) : (
            <>
              {isTabShow && groups ? (
                <div className="tab-section">
                  <Tab
                    tabTitles={[
                      ...Object.keys(groups).map(
                        (group: any, index: number) => (
                          <p
                            key={index}
                            id={
                              group.toLowerCase() === "diagnostic exam" ||
                              group.toLowerCase() === "diagnostic exams" ||
                              group.toLowerCase() === "diagnostic exam a" ||
                              group.toLowerCase() === "diagnostic exam b"
                                ? "home-diagnostic"
                                : `home-${group.toLowerCase()}`
                            }
                          >
                            {group}
                          </p>
                        )
                      ),
                      "Feedback",
                    ]}
                    tabContents={[
                      ...Object.keys(groups).map(
                        (group: any, index: number) => {
                            // Handle new ContentGroupingModel structure
                            const groupData = groups[`${group}`];
                            let contentToShow: any[] = [];
                            
                            if (groupData) {
                              // If it's the new structure (ContentGroupingModel)
                              if (groupData.NonDrillSmartContent || groupData.DrillSmartContent) {
                                // Add NonDrillSmartContent items
                                if (groupData.NonDrillSmartContent?.Content) {
                                  contentToShow = [...groupData.NonDrillSmartContent.Content];
                                }
                                // Add each DrillSmartGrouping as a single item (not the individual Content within it)
                                if (groupData.DrillSmartContent && Array.isArray(groupData.DrillSmartContent)) {
                                  groupData.DrillSmartContent.forEach((drillGroup: any) => {
                                    // Add the entire DrillSmartGrouping object, marked so it can be identified
                                    contentToShow.push({
                                      ...drillGroup,
                                      _isDrillSmartGrouping: true
                                    });
                                  });
                                }
                              } else if (Array.isArray(groupData)) {
                                // Legacy structure: direct array of content objects
                                contentToShow = groupData;
                              }
                            }
                            
                            return (
                              <TabClassHomeWork
                                key={index}
                                isMobile={screen.width < MOBILE_WIDTH}
                                works={contentToShow}
                                type={`${group.toLowerCase()}`}
                                contentObjectType={contentObjectType}
                                theme={theme}
                                itemPageNo={itemPageNo}
                              />
                          )
                          }
                      ),
                      <TabFeedback
                        theme={theme}
                        data={segmentObj}
                        handleRefresh={handleRefreshCourseWork}
                      />,
                    ]}
                    defaultActiveTab={0}
                  />
                </div>
              ) : null}
            </>
          )}
        </div>
      </div>
      <Modal
        onClose={handleMessageOnboardClose}
        isOpen={isMessageOnBoarOpen}
        theme="light"
        style="message-body-modal-custom-style"
      >
        <div className="message-body-wrapper">
          <div className="header-section">
            <div className="left-section">
              <div className="profile-pic">
                <img src={profileImage} alt="" />
              </div>
              <div className="name-subject-section">
                <div className="name">
                  <Typography
                    label="Matthew Dempsey"
                    variant="h6Medium"
                    styles="custom-typography-style"
                  />
                </div>
                <div className="subject">
                  <Typography
                    label="Subject: MCAT GChem Class 1"
                    variant="h8Book"
                    styles="custom-typography-style"
                  />
                </div>
              </div>
            </div>
            <div className="right-section" onClick={handleMessageOnboardClose}>
              <CloseIcon
                theme={theme}
                color="#9D9D9D"
                style="close-icon-custom-style"
              />
            </div>
          </div>
          <div className="body-section">
            <div className="display-area">
              <div className={classNames("onboard-message-wrapper")}>
                <OnboardMessageBody
                  isSent={false}
                  message={`Hi Mr. Dempey

Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed facilisis ullamcorper lectus, at egestas magna iaculis nec. Suspendisse dignissim feugiat vehicula. Quisque venenatis tempus lorem, et rutrum sem viverra et. Curabitur fermentum id ex a fermentum. Suspendisse venenatis risus lectus, at feugiat ante porttitor at. Mauris fermentum sem turpis, sed pharetra libero luctus non. Suspendisse nunc eros, egestas in nisi vel, tempor finibus dolor. Vestibulum eu sem ut augue convallis maximus at id erat.

Thank you,
Cynthia`}
                />
                <OnboardMessageBody
                  isSent={true}
                  message={`Hi Cynthia

Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed facilisis ullamcorper lectus, at egestas magna iaculis nec. Suspendisse dignissim feugiat vehicula. Quisque venenatis tempus lorem, et rutrum sem viverra et. Curabitur fermentum id ex a fermentum.`}
                />
              </div>
            </div>

            <div className="text-editor-section">
              <TextEditor />
            </div>
          </div>
        </div>
      </Modal>
      <RefreshModal
        isOpen={isRefreshModalOpen.isOpen}
        handleOnClose={handleRefreshModalClose}
        theme={theme}
        contentObjectType={
          isRefreshModalOpen.data !== ""
            ? isRefreshModalOpen.data
            : contentObjectType
        }
        isFetching={
          isFetching ||
          isFetchingTestScores ||
          isFetchingPracticeTests ||
          isFetchingPracticeResults ||
          isFetchingOverallProgress ||
          StudyPlannerRefetchResult.isFetching ||
          aiRecommendationRefetchResult.isFetching
        }
        handleRefresh={handleRefreshCourseWork}
      />
      <DrillModal
        handleUpdateModalClose={handleUpdateModalClose}
        openUpdateModalState={openUpdateModalState}
        theme={theme}
        refetchData={handleRefreshCourseWork}
        isFetchingOtherAPIs={
          isFetching ||
          isFetchingOverallProgress ||
          isFetchingTestScores ||
          StudyPlannerRefetchResult.isFetching ||
          aiRecommendationRefetchResult.isFetching
        }
      />
    </>
  );
};
